import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import FunnelsAPI from '../../api/funnels';

export const state = {
    records: [],
    uiFlags: {
        isFetching: false,
        isCreating: false,
        isUpdating: false,
        isDeleting: false,
    },
};

export const getters = {
    getFunnels(_state) {
        return _state.records;
    },
    getFunnel: _state => id => {
        return _state.records.find(funnel => funnel.id === Number(id));
    },
    getUIFlags(_state) {
        return _state.uiFlags;
    },
};

export const actions = {
    get: async ({ commit }) => {
        commit(types.SET_FUNNELS_UI_FLAG, { isFetching: true });
        try {
            const response = await FunnelsAPI.get();
            commit(types.SET_FUNNELS, response.data);
            return response.data;
        } catch (error) {
            throw error;
        } finally {
            commit(types.SET_FUNNELS_UI_FLAG, { isFetching: false });
        }
    },

    create: async ({ commit }, { withDefaultStages = false, ...funnelData }) => {
        commit(types.SET_FUNNELS_UI_FLAG, { isCreating: true });
        try {
            const response = await FunnelsAPI.create(funnelData, withDefaultStages);
            commit(types.ADD_FUNNEL, response.data);
            return response.data;
        } catch (error) {
            throw error;
        } finally {
            commit(types.SET_FUNNELS_UI_FLAG, { isCreating: false });
        }
    },

    update: async ({ commit }, { id, ...funnelData }) => {
        commit(types.SET_FUNNELS_UI_FLAG, { isUpdating: true });
        try {
            const response = await FunnelsAPI.update(id, funnelData);
            commit(types.EDIT_FUNNEL, response.data);
            return response.data;
        } catch (error) {
            throw error;
        } finally {
            commit(types.SET_FUNNELS_UI_FLAG, { isUpdating: false });
        }
    },

    delete: async ({ commit }, id) => {
        commit(types.SET_FUNNELS_UI_FLAG, { isDeleting: true });
        try {
            await FunnelsAPI.delete(id);
            commit(types.DELETE_FUNNEL, id);
        } catch (error) {
            throw error;
        } finally {
            commit(types.SET_FUNNELS_UI_FLAG, { isDeleting: false });
        }
    },
};

export const mutations = {
    [types.SET_FUNNELS_UI_FLAG](_state, data) {
        _state.uiFlags = {
            ..._state.uiFlags,
            ...data,
        };
    },

    [types.SET_FUNNELS]: MutationHelpers.set,
    [types.ADD_FUNNEL]: MutationHelpers.create,
    [types.EDIT_FUNNEL]: MutationHelpers.update,
    [types.DELETE_FUNNEL]: MutationHelpers.destroy,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
